import { Row, Divider } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import get from "lodash/get";
import slice from "lodash/slice";
import sortBy from "lodash/sortBy";
import round from "lodash/round";

import GraphGrid from "../graphGrid";
import GraphHeader from "./graphHeader";


import { getTransformedMinutes } from "../../../utilities/helpers";
import { fetchScopeNodeHierarchy } from "../../../redux/actions/locationActions";

const ExtrutionGraphSection = ({
  selectedTemplate,
  onChangeParams,
  filter,
  setLoading,
}) => {
  const data = get(selectedTemplate, "graph_report");
  const dispatch = useDispatch();
  const locationId = get(selectedTemplate, "template.location_id");
  const [address, setAddress] = useState();

  const getLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchScopeNodeHierarchy("LOCATION", locationId))
      .then((result) => {
        setAddress(get(result, "name"));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (locationId) {
      getLocation(locationId);
    }
  }, [locationId]);

  return (
    <>
      <GraphHeader 
       filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams} />

      <Row id="content-container">
        <GraphGrid
          type="time"
          graphId={1}
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          selectedTemplate={selectedTemplate}
          filter={filter}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours")?round(get(selectedTemplate, "meta.total_off_hours")):0
              ),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours")?round(get(selectedTemplate, "meta.total_idle_hours")):0
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours")?round(get(selectedTemplate, "meta.total_working_hours")):0
              ),
              label: "Working Hours",
            },
          ]}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="time"
          label={"Length"}
          stats={sortBy(slice(get(data, "length_graph", [])), "date")}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.total_length") ?get(selectedTemplate, "meta.total_length"):0} Meter`,
              label: "Total length",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={3}
          type="time"
          label={"Speed"}
          stats={get(data, "speed_graph", [])}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_speed")?round(get(selectedTemplate, "meta.avg_speed")):0} Meter/min`,
              label: "Avg. Speed",
            },
          ]}
                   selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="time"
            graphId={4}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${get(
                  selectedTemplate,
                  "meta.total_power_consumption"
                )?get(
                  selectedTemplate,
                  "meta.total_power_consumption"
                ):0} Kwh`,
                label: "Power Consumption",
              },
            ]}
                       selectedTemplate={selectedTemplate}
           filter={filter}
          />
        )}
      </Row>
    </>
  );
};

export default ExtrutionGraphSection;
